import { render, staticRenderFns } from "./TokenExpireDialogModal.vue?vue&type=template&id=5c8c4773&scoped=true"
import script from "./TokenExpireDialogModal.vue?vue&type=script&lang=js"
export * from "./TokenExpireDialogModal.vue?vue&type=script&lang=js"
import style0 from "./TokenExpireDialogModal.vue?vue&type=style&index=0&id=5c8c4773&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8c4773",
  null
  
)

export default component.exports